import React from 'react';
import { Avatar } from 'antd';
import { senderInitials } from '../models/mailListModel';
import { useMailSenderImage } from '../viewmodels/useMailSenderImage';
import './mail-sender-image.css';

export default function MailSenderAvatar({ from, image }) {
  const senderImage = useMailSenderImage(image);
  if (senderImage.url) return <img className="mail-sender-image" src={senderImage.url} alt="" aria-hidden="true" onError={senderImage.onError} />;
  return <Avatar className="mail-sender-avatar" size={38} aria-hidden="true">{senderInitials(from)}</Avatar>;
}
